import { IMSObject, IMSId, LabelFormatSetting } from './ims-object';

export class MaterialDemandPosition extends IMSObject {
  static fromDto(
    dto: MaterialDemandPositionDTO,
    databag?: any,
    labelSettings?: LabelFormatSetting
  ) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/MaterialDemandPosition',
      },
      dto.label,
      labelSettings || {
        primary: {
          value: '{0}',
          databagKeys: ['label'],
        },
      },
      new IMSObject(
        dto.materialdemand.id,
        undefined,
        dto.materialdemand.label,
        'ims/MaterialDemand'
      ),
      new IMSObject(
        dto.materialdelivery.id,
        undefined,
        dto.materialdelivery.label,
        'ims/MaterialDelivery'
      ),
      new IMSObject(
        dto.material.id,
        undefined,
        dto.material.label,
        'ims/Material'
      ),
      dto.materialdescription,
      dto.posstatus,
      dto.comment,
      dto.amount,
      dto.drawingparttnbr,
      dto.dlvinfopalletnbr,
      dto.dlvinfoloadingorder,
      dto.dlvinfocomment
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }

    return obj;
  }

  public get deliveryInfoPalletComment(): string {
    return this.databag?.['dlvinfopalletcomment'];
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    labelFormatSettings: LabelFormatSetting,
    public materialDemand: IMSObject,
    public materialDelivery: IMSObject,
    public material: IMSObject,
    public materialDescription: string,
    public posStatus: string,
    public comment: string,
    public amount: number,
    public drawingPartNumber: string,
    public deliveryInfoPalletNumber: string,
    public deliveryInfoLoadingOrder: string,
    public deliveryInfoComment: string
  ) {
    super(
      id.imsId,
      id.secondaryId,
      label,
      'ims/MaterialDemandPosition',
      labelFormatSettings
    );
  }
}

export interface MaterialDemandPositionDTO {
  id: number;
  secondaryid: number;
  label: string;
  materialdemand: {
    id: number;
    label: string;
  };
  materialdescription: string;
  posstatus: string;
  comment: string;
  amount: number;
  materialdelivery: {
    id: number;
    label: string;
  };
  material: {
    id: number;
    label: string;
  };
  drawingparttnbr: string;
  dlvinfopalletnbr: string;
  dlvinfoloadingorder: string;
  dlvinfocomment: string;
}
